<template>

    <div class="c-pagination c-search-pagination">
        <a :class="{disabled: currentPage === 1 }"
            aria-label="Go to previous page"
           @click.prevent="previousPage(currentPage)"
           class="previous page-numbers"
           href="#previous"><i class="fal fa-arrow-left" aria-hidden="true"></i><span class="u-hidden-visually">Previous</span></a>

        <a v-if="firstPage !== 1"
            aria-label="Go to page 1"
            :href="'#1'"
            @click.prevent="changePage(1)"
            class="page-numbers page-numbers--number"
            >1<template v-if="showFirstEllipsis"> ...</template></a>

        <a :class="{current : page === currentPage}"
            :aria-label="'Go to page ' + page"
            :key="'pagination-' + page"
            :href="'#' + page"
            @click.prevent="changePage(page)"
            class="page-numbers page-numbers--number"
            v-for="page in pageList()">{{ page }}</a>

        <a v-if="lastPage !== totalPages" 
            :aria-label="'Go to page ' + totalPages"
            :href="'#' + totalPages"
            @click.prevent="changePage(totalPages)"
            class="page-numbers page-numbers--number"
            ><template v-if="showLastEllipsis">... </template>{{ totalPages }}</a>

        <a :class="{disabled: currentPage === totalPages}"
           aria-label="Go to next page"
           @click.prevent="nextPage(currentPage)" class="next page-numbers"
           href="#next"><i class="fal fa-arrow-right" aria-hidden="true"></i><span class="u-hidden-visually">Next</span></a>
    </div>

</template>

<script>
    import {EventBus} from "../event-bus"

    export default {
        name: "Pagination",
        props: ['totalPages', 'currentPage'],
        computed: {
            firstPage() {
                return this.pageList()[0]
            },
            lastPage() {
                return this.pageList().slice(-1)[0]
            },
            showFirstEllipsis() {
                return this.currentPage - (this.maxItems / 2) > 3
            },
            showLastEllipsis() {
                return this.currentPage + (this.maxItems / 2) + 1 < this.totalPages
            }
        },
        data() {
            return {
                maxItems: 7,
            }
        },
        methods: {
            changePage(pageNumber) {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
                EventBus.$emit('update-page', pageNumber)
            },
            nextPage(pageNumber) {
                pageNumber++
                let page = pageNumber >= this.totalPages ? this.totalPages : pageNumber
                this.changePage(page)
            },
            previousPage(pageNumber) {
                pageNumber--
                let page = pageNumber <= 1 ? 1 : pageNumber
                this.changePage(page)
            },
            pageList() {
                let pagesToShow = Math.min(this.totalPages, this.maxItems + 1)
                let max = Math.max(parseInt(this.currentPage - this.maxItems / 2), 1)
                let offset = Math.min(Math.max(this.totalPages - this.maxItems, 1), max)
                return Array.from({length: pagesToShow}, (x, i) => i + offset)
            }
        }
    }
</script>

<style scoped>
    a.page-numbers {
        color: black;
    }
    a.page-numbers.current {
        color: red;
    }
    a.disabled {
        pointer-events: none;
        cursor: default;
    }
</style>
